import { FunctionComponent } from 'react'

import { Provider } from 'react-redux'
import reduxStore from 'redux/store'
import { StylesProvider } from '@material-ui/core' // This is necessary to stop MUI overriding our styles

import UserWrapper from './UserWrapper'
import LayoutWrapperComponent from './LayoutWrapperComponent'

const LayoutWrapper: FunctionComponent = (props) => (
  <Provider store={reduxStore}>
    <StylesProvider injectFirst>
      <UserWrapper>
        <LayoutWrapperComponent {...props} />
      </UserWrapper>
    </StylesProvider>
  </Provider>
)

export default LayoutWrapper
